import { Injectable, inject } from '@angular/core';
import {
  MatSnackBar,
  type MatSnackBarConfig,
  type MatSnackBarRef,
  type TextOnlySnackBar,
} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private readonly snackbar = inject(MatSnackBar);
  private readonly defaultConfig: MatSnackBarConfig = {
    verticalPosition: 'bottom', // 'top' | 'bottom'
    horizontalPosition: 'start', // 'start' | 'center' | 'end' | 'left' | 'right'
    duration: 6000,
    politeness: 'polite',
    panelClass: ['snackbar-good'],
  };

  showMessage(
    message: string,
    action = '',
    config?: Partial<MatSnackBarConfig>
  ): MatSnackBarRef<TextOnlySnackBar> {
    let panelClass = ['snackbar-good'];
    if (config?.panelClass) {
      if (typeof config.panelClass === 'string') {
        panelClass.push(config.panelClass);
      } else {
        panelClass = [...panelClass, ...config.panelClass];
      }
    }
    return this.snackbar.open(message, action, {
      ...this.defaultConfig,
      ...config,
      panelClass,
    } as MatSnackBarConfig);
  }

  showError(
    message: string,
    action?: string,
    config?: Partial<MatSnackBarConfig>
  ): MatSnackBarRef<TextOnlySnackBar> {
    let panelClass = ['snackbar-error'];
    if (config?.panelClass) {
      if (typeof config.panelClass === 'string') {
        panelClass.push(config.panelClass);
      } else {
        panelClass = [...panelClass, ...config.panelClass];
      }
    }
    return this.showMessage(message, action, { ...config, panelClass });
  }

  hide(): void {
    this.snackbar.dismiss();
  }
}
